var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',{staticClass:"fw--toast"},[_c('div',{staticClass:"fw--toast-box"},[(_vm.icon)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.message))])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }